import * as React from 'react'

import { Tabs as TabsBase, TabsProps, PreferenceStore } from 'app2/components';

import { Tab } from './Tab';

export function Tabs<T extends PreferenceStore = any>(props:TabsProps<T>) {
  return <TabsBase component={Tab} {...props} />
}
